module.exports = __webpack_public_path__ + "img/welding-12.bde17570.jpg";